import '../../app.es6';
import angular from 'angular';

class SimplicitySignInController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = '';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = false;
    this.commonFactory.overlayHidden();

    let sessionRole = this.$sessionStorage[Const.LSAPP_ROLE];
    let role = localStorage.getItem(Const.LSAPP_ROLE);
    this.role = role;

    if (role === this.Const.LSAPP_ROLE_MEMBER) {
      this.$sessionStorage[this.Const.SSAPP_SMALL_HEIGHT] = '';
    } else {
      this.$sessionStorage[this.Const.SSAPP_SMALL_HEIGHT] = 'small-height';
    }

    // Cognito Credentials
    let userId = localStorage.getItem(Const.LSKEY_USER_ID);
    let jwtToken = localStorage.getItem(Const.LSKEY_USER_ID_TOKEN);
    let accessKeyId = localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID);
    let secretAccessKey = localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
    let sessionToken = localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN);
    let refreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
    let accessToken = localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN);
    let isCredential = false;
    if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
      isCredential = true;
    }
    if (!sessionRole && role && isCredential) {
      this.simplicitySignIn();
    } else {
      this.goToSignIn();
    }

    SimplicitySignInController.$inject = [
      '$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const'
    ];
  }

  simplicitySignIn () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    switch (this.role) {
      case this.Const.LSAPP_ROLE_STAFF:
      case this.Const.LSAPP_ROLE_RECEPTION:
      case this.Const.LSAPP_ROLE_S_ADMIN:
      case this.Const.LSAPP_ROLE_C_ADMIN:
        this.commonApiFactory.getStaffsMe()
        .then((staff) => {
          switch (staff.role.name) {
            case this.Const.LSAPP_ROLE_C_ADMIN: // Company Admin
              this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_C_ADMIN);
              this.$sessionStorage[this.Const.SSAPP_COMPANY_ID] = staff.companyId;
              this.$location.path('/admin/school');
              break;
            case this.Const.LSAPP_ROLE_S_ADMIN: // School Admin
              this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_S_ADMIN);
              this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = staff.data.schoolId;
              this.$location.path('/admin');
              break;
            default: // coach,reception
              this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_STAFF);
              this.$sessionStorage[this.Const.SSAPP_COACH_NAME] = staff.name;
              if (staff.gender === null) {
                staff.gender = 0;
              }
              this.$sessionStorage[this.Const.SSAPP_COACH_GENDER] = staff.gender;
              this.$location.path('/staff');
          }
          this.commonFactory.overlayHidden();
          this.$scope.$apply();
        })
        .catch(() => {
          this.$location.path('/staff/login');
          this.commonFactory.overlayHidden();
          this.$scope.$apply();
        });
        break;
      case this.Const.LSAPP_ROLE_MEMBER:
      default:
        this.commonApiFactory.getMembersMe()
        .then((member) => {
          this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_MEMBER);
          // 生徒情報を追加時に他修正が必要な箇所
          // ・member-sign-in-controller.es6
          // ・password-change-controller.es6
          this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = member.id;
          this.$sessionStorage[this.Const.SSAPP_USER_NAME] = member.name;
          this.$sessionStorage[this.Const.SSAPP_GENDER] = member.gender;
          this.$sessionStorage[this.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
          this.$sessionStorage[this.Const.SSAPP_SENSOR_RENTAL] = member.data.sensorRental;
          this.$location.path('/member');
          this.commonFactory.overlayHidden();
          this.$scope.$apply();
        })
        .catch(() => {
          this.$location.path('/member/login');
          this.commonFactory.overlayHidden();
          this.$scope.$apply();
        });
    }
  }

  goToSignIn () {
    switch (this.role) {
      case this.Const.LSAPP_ROLE_STAFF:
      case this.Const.LSAPP_ROLE_RECEPTION:
      case this.Const.LSAPP_ROLE_S_ADMIN:
      case this.Const.LSAPP_ROLE_C_ADMIN:
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
        this.$location.path('/staff/login');
        break;
      case this.Const.LSAPP_ROLE_MEMBER:
      default:
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
        this.$location.path('/member/login');
        break;
    }
  }
}

angular.module('myApp').controller('SimplicitySignInController', SimplicitySignInController);



// WEBPACK FOOTER //
// ./app/components/simplicity-sign-in/simplicity-sign-in-controller.es6